import React, { useEffect, useState } from 'react'
import { Chart } from 'primereact/chart';

const Narrationwise = (props) => {

    const [narrationWiseDataSet, setNarrationWiseDataSet] = useState([])

    const narrationWiseData = props?.narrationwiseData;

    const narrations = narrationWiseData?.map((item) => item?.status);

    const successfulData = narrationWiseData?.map((item) => item?.successful) || 0;
    const validationSuccessfulData = narrationWiseData?.map((item) => item?.validationSuccessful) || 0;
    const checkerApprovedData = narrationWiseData?.map((item) => item?.checkerApproved) || 0;
    const checkerRejectedData = narrationWiseData?.map((item) => item?.checkerRejected) || 0;

    useEffect(() => {
        const narrationWiseDataSet = {
            labels: narrations,
            datasets: [
                {
                    type: 'bar',
                    label: 'Validation Successful',
                    data: validationSuccessfulData,
                    // fill: false,
                    backgroundColor: 'rgba(84, 153, 199, 0.5)'
                },
                {
                    type: 'bar',
                    label: 'Approved',
                    data: checkerApprovedData,
                    // fill: false,
                    backgroundColor: 'rgba(214, 137, 16, 0.5)'
                },
                {
                    type: 'bar',
                    label: 'Rejected',
                    data: checkerRejectedData,
                    // fill: false,
                    backgroundColor: 'rgba(169, 50, 38, 0.5)'
                },
                {
                    type: 'bar',
                    label: 'Successful',
                    data: successfulData,
                    // fill: false,
                    backgroundColor: 'rgba(34, 153, 84, 0.5)'
                },
            ]
        };
        setNarrationWiseDataSet(narrationWiseDataSet)
    }, [props]);

    const getLightTheme = () => {
        let basicOptions = {
            title: {
                display: true,
                text: 'Narrationwise Summary',
                fontSize: 14,
            },
            tooltips: {
                mode: 'index',
                intersect: false
            },
            responsive: true,
            scales: {
                xAxes: [{
                    stacked: true,
                    ticks: {
                        fontColor: '#495057'
                    },
                    gridLines: {
                        color: '#ebedef'
                    }
                }],
                yAxes: [{
                    stacked: true,
                    ticks: {
                        fontColor: '#495057',
                        beginAtZero: true
                    },
                    gridLines: {
                        color: '#ebedef'
                    }
                }]
            },
            legend: {
                labels: {
                    fontColor: '#495057',
                    fontSize: 10,
                    boxWidth: 10
                }
            }
        };
        return {
            basicOptions,
        }
    }

    const { basicOptions } = getLightTheme();

    const isDataAvailable =
        props?.narrationwiseData &&
        Array.isArray(props?.narrationwiseData) &&
        props?.narrationwiseData?.length > 0;

    return (
        <>

            <div className="p-col-4">
                <div className="card graph_card position_relative">
                    {/* <h5>Narrationwise Summary</h5> */}
                    {
                        isDataAvailable ?
                            <Chart type="bar" data={narrationWiseDataSet} options={basicOptions} height="290px" />

                            :
                            <div className='no_records'>
                                No Records Found
                            </div>
                    }
                </div>
            </div>

        </>
    )
}

export default Narrationwise